import { render, staticRenderFns } from "./LimitsTableHeader.vue?vue&type=template&id=0e94d52c&"
import script from "./LimitsTableHeader.vue?vue&type=script&lang=ts&"
export * from "./LimitsTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports